import { TextField } from '@chronosphereio/chrono-ui';
import { MockDataQuerySpec } from '@/core';
import { OptionsEditorColumn, OptionsEditorControl } from '@/plugin-editor-components';
import { OptionsEditorProps } from '@/plugin-system';

export function MockDataQueryEditor(props: OptionsEditorProps<MockDataQuerySpec>) {
  if (props.dataType === 'Table') {
    return null;
  }

  return (
    <OptionsEditorColumn>
      <OptionsEditorControl
        label="Total Series"
        description="Number of series to return"
        control={
          <TextField
            type="number"
            value={props.value.totalSeries}
            onChange={(e) => {
              props.onChange({
                ...props.value,
                totalSeries: Number(e.target.value),
              });
            }}
          />
        }
      />
      <OptionsEditorControl
        label="Total Datapoints"
        description="Number of datapoints to return"
        control={
          <TextField
            type="number"
            value={props.value.totalDatapoints}
            onChange={(e) => {
              props.onChange({
                ...props.value,
                totalDatapoints: Number(e.target.value),
              });
            }}
          />
        }
      />
      <OptionsEditorControl
        label="Seed"
        description="This will change the series name and the shape of the data. To ensure consistency when using the resulting chart for testing, use a fixed seed."
        control={
          <TextField
            type="number"
            value={props.value.seed}
            onChange={(e) => {
              props.onChange({
                ...props.value,
                seed: Number(e.target.value),
              });
            }}
          />
        }
      />
      <OptionsEditorControl
        label="Y Variation"
        description="The multiplier for the y-axis variation to simulate seasonality"
        control={
          <TextField
            type="number"
            value={props.value.yVariationMultiplier}
            onChange={(e) => {
              props.onChange({
                ...props.value,
                yVariationMultiplier: Number(e.target.value),
              });
            }}
          />
        }
      />
      <OptionsEditorControl
        label="Randomness"
        description="Increase to simulate natural variability. Raising above 1000 gives best results."
        control={
          <TextField
            type="number"
            value={props.value.randomnessMultiplier}
            onChange={(e) => {
              props.onChange({
                ...props.value,
                randomnessMultiplier: Number(e.target.value),
              });
            }}
          />
        }
      />
      <OptionsEditorControl
        label="Outlier Ratio"
        description="Ratio of series that will contain outliers. Values should be between 0 and 1"
        control={
          <TextField
            type="number"
            value={props.value.outlierRatio}
            InputProps={{ inputProps: { min: 0, max: 1 } }}
            onChange={(e) => {
              props.onChange({
                ...props.value,
                outlierRatio: Number(e.target.value),
              });
            }}
          />
        }
      />
      <OptionsEditorControl
        label="Outlier Multiplier"
        description="Controls magnitude of outliers to exaggerate their impact"
        control={
          <TextField
            type="number"
            value={props.value.outlierMultiplier}
            onChange={(e) => {
              props.onChange({
                ...props.value,
                outlierMultiplier: Number(e.target.value),
              });
            }}
          />
        }
      />
      <OptionsEditorControl
        label="Sparse Ratio"
        description="This controls the ratio of sparse datapoints. Value should be between 0 (no data) and 1 (no sparsity)"
        control={
          <TextField
            type="number"
            value={props.value.sparseRatio}
            InputProps={{ inputProps: { min: 0, max: 1 } }}
            onChange={(e) => {
              props.onChange({
                ...props.value,
                sparseRatio: Number(e.target.value),
              });
            }}
          />
        }
      />
    </OptionsEditorColumn>
  );
}
